import { useState } from 'react'

import { Button, LargeBodyText } from '@/components/core'
import { IntroCarousel } from '@/components/widgets/IntroCarousel'
import { redirectToNativeBrowser, copyCurrentUrl } from '@/lib/inAppBrowser'
import type { InAppBrowserPlatform } from '@/lib/inAppBrowser'

import '@/pages/Login/components/LoginPanel/styles.scss'
import '@/pages/Login/index.scss'

interface InAppBrowserScreenProps {
  platform: InAppBrowserPlatform
  app: string | null
}

export function InAppBrowserScreen({ platform, app }: InAppBrowserScreenProps) {
  const [copied, setCopied] = useState(false)

  const browserName = platform === 'ios' ? 'Safari' : 'Chrome'
  const appLabel = app ?? 'this in-app browser'

  const handleOpen = () => {
    redirectToNativeBrowser(platform)
  }

  const handleCopy = async () => {
    await copyCurrentUrl()
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className="login-page">
      <IntroCarousel />
      <div className="login-panel">
        <div className="login-panel__content">
          <h1 className="login-panel__title">Open in {browserName} to Sign in</h1>
          <LargeBodyText>
            {appLabel} doesn&apos;t support Google sign-in.
            <br />
            If {browserName} didn't launch, tap below or paste the link into your browser manually.
          </LargeBodyText>
          <Button variant="primary" onClick={handleOpen}>
            Open in {browserName}
          </Button>
          <Button variant="primary-light" onClick={handleCopy}>
            {copied ? 'Link copied!' : 'Copy link'}
          </Button>
        </div>
      </div>
    </div>
  )
}
